import * as React from 'react'
import * as Styled from './Banner.styles'

const Banner = ({
  image = null,
  mobileImage = null,
  mainContent = null,
  backgroundColor = null,
  backgroundImage = null,
  mobileBackgroundImage = null,
  textColor = null,
  mobileTextColor = null,
  centerAligned = false,
  layout = '20/80',
  imageAlignment = false,
  contentAlignment = false,
  ...props
}) => (
  <Styled.Section
    className="leshen-banner"
    backgroundColor={backgroundColor}
    textColor={textColor}
    mobileTextColor={mobileTextColor}
    {...props}
  >
    {backgroundImage && (
      <Styled.BackgroundImage
        mobileBackgroundImage={Boolean(mobileBackgroundImage)}
      >
        {backgroundImage}
      </Styled.BackgroundImage>
    )}
    {mobileBackgroundImage && (
      <Styled.MobileBackgroundImage>
        {mobileBackgroundImage}
      </Styled.MobileBackgroundImage>
    )}
    <Styled.Content
      layout={layout}
      mobileImage={Boolean(mobileImage)}
      hasBackgroundImage={Boolean(backgroundImage)}
    >
      <Styled.ImageContainer
        className="image-container"
        imageAlignment={imageAlignment}
      >
        {image && <div className="desktop-image">{image}</div>}
        {mobileImage && <div className="mobile-image">{mobileImage}</div>}
      </Styled.ImageContainer>
      <Styled.TextContent
        className="text-content"
        centerAligned={centerAligned}
        contentAlignment={contentAlignment}
      >
        {mainContent}
      </Styled.TextContent>
    </Styled.Content>
  </Styled.Section>
)
export default Banner
